export default __webpack_public_path__ + "static/media/bg.29b2eec8.mp4";